import { render, staticRenderFns } from "./infoItem.vue?vue&type=template&id=db06442e&scoped=true&"
import script from "./infoItem.vue?vue&type=script&lang=js&"
export * from "./infoItem.vue?vue&type=script&lang=js&"
import style0 from "./infoItem.vue?vue&type=style&index=0&id=db06442e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db06442e",
  null
  
)

export default component.exports